/**
 * Formatação do portal.
 *
 * Módulo próprio, e sem DOM, para caber no projeto de teste `web` do vitest —
 * que roda em `node` e só aceita `.ts`. É a fronteira que empurra a lógica
 * testável para fora do `.tsx`, onde ela fica visível.
 */

const DATA_CURTA = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const DATA_HORA = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function dataCurta(iso: string): string {
  return DATA_CURTA.format(new Date(iso));
}

export function dataHora(iso: string): string {
  return DATA_HORA.format(new Date(iso));
}

export function rotuloDeSituacao(chave: 'abertos' | 'resolvidos' | 'todos'): string {
  return { abertos: 'Em andamento', resolvidos: 'Resolvidos', todos: 'Todos' }[chave];
}

const METRICAS: Record<string, string> = {
  FIRST_RESPONSE: 'Primeira resposta',
  RESOLUTION: 'Resolução',
  UPDATE_INTERVAL: 'Atualização periódica',
};

export function rotuloDeMetrica(metrica: string): string {
  return METRICAS[metrica] ?? metrica;
}

/**
 * O prazo em português, a partir dos minutos restantes.
 *
 * Negativo é **vencido**, e é dito com essa palavra: "-120 min" obriga o leitor
 * a interpretar o sinal, e num portal de cliente a informação que importa é
 * justamente essa.
 */
export function prazoEmPalavras(restanteMinutos: number | null): string {
  if (restanteMinutos === null) return 'sem prazo';
  if (restanteMinutos < 0) return `vencido há ${duracao(-restanteMinutos)}`;
  return `faltam ${duracao(restanteMinutos)}`;
}

export function duracao(minutos: number): string {
  const inteiros = Math.max(0, Math.round(minutos));
  if (inteiros < 60) return `${inteiros} min`;
  const horas = Math.floor(inteiros / 60);
  const resto = inteiros % 60;
  if (horas < 24) return resto === 0 ? `${horas} h` : `${horas} h ${resto} min`;
  const dias = Math.floor(horas / 24);
  const sobra = horas % 24;
  return sobra === 0 ? `${dias} d` : `${dias} d ${sobra} h`;
}

export function tamanhoDeArquivo(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
